import { render, staticRenderFns } from "./AttributesView.vue?vue&type=template&id=af5986ca&scoped=true&"
import script from "./AttributesView.vue?vue&type=script&lang=js&"
export * from "./AttributesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5986ca",
  null
  
)

export default component.exports